export const APPLICATION_VERSION = "1.4.64";
